// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import PostReactivationFormPayloadRequestModel from '../../model/post-reactivation-form-payload-request-model';

export default (service: Servicelayer) => ({
  /**  */
  async postReactivationFormPayload(request: PostReactivationFormPayloadRequestModel, config?: RequestConfig) {
    const requestDTO = PostReactivationFormPayloadRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-reactivation-form-payload'] ?? 'widgets/Reactivation/PostReactivationFormPayload';
    const response = await service.post<any>(endpointPath, {
      query: {
        donationItem: requestDTO.donationItem,
        message: requestDTO.message,
        contactId: requestDTO.contactId,
        'contact.IsCompany': requestDTO['contact.IsCompany'],
        'contact.CompanyName': requestDTO['contact.CompanyName'],
        'contact.Salutation': requestDTO['contact.Salutation'],
        'contact.FirstName': requestDTO['contact.FirstName'],
        'contact.LastName': requestDTO['contact.LastName'],
        'contact.DateOfBirth': requestDTO['contact.DateOfBirth'],
        'contact.EMail': requestDTO['contact.EMail'],
        'contact.PhoneNumber': requestDTO['contact.PhoneNumber'],
        'contact.MobilePhoneNumber': requestDTO['contact.MobilePhoneNumber'],
        'contact.CompanyPhone': requestDTO['contact.CompanyPhone'],
        'contact.Street': requestDTO['contact.Street'],
        'contact.HouseNumber': requestDTO['contact.HouseNumber'],
        'contact.AddressLine1': requestDTO['contact.AddressLine1'],
        'contact.AddressLine2': requestDTO['contact.AddressLine2'],
        'contact.POBox': requestDTO['contact.POBox'],
        'contact.PostalCode': requestDTO['contact.PostalCode'],
        'contact.City': requestDTO['contact.City'],
        'contact.CountryIso2': requestDTO['contact.CountryIso2'],
        'contact.Website': requestDTO['contact.Website'],
        newsletterItems: requestDTO.newsletterItems,
        characteristicItems: requestDTO.characteristicItems,
        languageIso2: requestDTO.languageIso2,
        tenantKey: requestDTO.tenantKey,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
});
